export default __webpack_public_path__ + "14ac3f6d76a82f34da37b94e24bc5336.svg";